import { getSignInAuth, unclaimedSessionLength } from '@/config/auth';
import { UnclaimedSessionOverError } from './errors';
export default async function getCurrentUser() {
    const user = await getSignInAuth()
        .currentAuthenticatedUser()
        .catch(() => null);
    if (!user) {
        return null;
    }
    const { 'custom:provider:name': provider, email_verified: verified, email, given_name: givenName = 'User', family_name: familyName = '', picture, sub: id, } = user.attributes;
    const { auth_time: authAt } = (((user.signInUserSession || {}).accessToken || {}).payload || {});
    if (provider === 'unclaimed' && authAt && (Date.now() > ((authAt * 1000) + unclaimedSessionLength))) {
        throw new UnclaimedSessionOverError();
    }
    return {
        provider, email, verified, givenName, familyName, picture, id,
    };
}
